<template>
	<div class="content">
		<div class="title">
			<Header @changeSite="changeSite" :iseck="1"/>
		</div>
		<div class="body">
			<div class="left">
				<Box width="528" height="870" title="门禁管理">
					<div class="left-content">
						<div v-if="Object.keys(accessList[0]).length == 0" class="noAccess">
							<div class="pic"></div>
							<div class="text">暂无门禁</div>
						</div>
						<Access v-if="Object.keys(accessList[0]).length != 0" :accessInfo="accessList[0]"
							@showDetail="recordState = !recordState" />
					</div>
				</Box>
			</div>
			<div class="right">
				<div v-show="recordState" class="record">
					<div class="record-head">
						<div style="display: flex;">
							<div class="date-picker">
								<el-date-picker v-model="dateRange" type="daterange" unlink-panels
									start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
							</div>
							<div class="button">
								<el-button type="primary" @click="query">查询</el-button>
							</div>
						</div>
						<img src="@/assets/img/关闭.png" class="close" @click="recordState = false" alt="">
					</div>
					<div class="record-body" id="accessRecord">
						<el-table :data="accessRecorList" header-cell-class-name="header-cell-style"
							header-row-class-name="header-row-style" cell-class-name="cell-style"
							row-class-name="row-style" stripe height="700" style="width: 100%;">
							<el-table-column prop="FacePic" label="头像">
								<template slot-scope="scope">
									<img :src="scope.row.FacePic?('data:image/png;base64,' + scope.row.FacePic):require('@/assets/img/userDefault.png')"
										alt="" style="width:48px; height:48px">
								</template>
							</el-table-column>
							<el-table-column prop="Name" label="姓名"></el-table-column>
							<el-table-column prop="Department" label="部门"></el-table-column>
							<el-table-column prop="EmployeeNumber" label="工号"></el-table-column>
							<el-table-column prop="EnterDate" label="进入时间"></el-table-column>
						</el-table>
					</div>
				</div>
				<Box width="1064" height="870"
					:title="'监控视频' + (videoList.length > 0 ? (': ' + videoList[currentVideoIndex].videoName) : '')">
					<div class="right-video">
						<div class="bigVideo">
							<div v-if="videoList.length < 1" class="noVideo">
								<div class="pic"></div>
								<div class="text">暂无监控视频</div>
							</div>
							<Video :videoList="videoList[currentVideoIndex]" v-if="videoList.length>0"></Video>
						</div>
						<div class="videoListContainer" v-if="videoList.length > 0">
							<div class="videoList">监控列表</div>
							<div class="search row-center">
								<input type="text" placeholder="请输入关键词" v-model="monitorFilterText">
								<img src="../../../assets/img/search.png" alt="">
							</div>
						</div>
						<div>
							<vue-horizontal responsive ref="horizontal" v-if="videoList.length > 0" :button-between="false">
								<SmallVideo v-for="(item,i) in videoList" :width="monitorFilter(item)" :key="i"
									:currentIndex="currentVideoIndex" :videoList="item" @changeVideo="changeVideo" />
								<template v-slot:btn-prev>
									<div class="btn-prev"></div>
								</template>
								<template v-slot:btn-next>
									<div class="btn-next"></div>
								</template>
							</vue-horizontal>
						</div>
						<div v-if="videoList.length == 0">

						</div>
					</div>
				</Box>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../Header";
	import Box from "../Box";
	import Access from "./Access"
	import Video from "./Video"
	import SmallVideo from "./SmallVideo"
	import VueHorizontal from 'vue-horizontal';
	import {
		GetSecurityDevices,
		GET_AREAS
	} from '../../../api/common'
	export default {
		name: "SecurityMonitoring",
		components: {
			Header,
			Box,
			Access,
			Video,
			SmallVideo,
			VueHorizontal
		},
		data() {
			return {
				areaId: -1,
				recordState: false,
				accessList: [{}],
				currentVideoIndex: 0,
				videoList: [],
				accessRecorList: [],
				dateRange: '',
				monitorFilterText: '',
			}
		},
		created() {
			GET_AREAS().then(res => {
				console.log(res,"res")
				this.areaId = res.data.data.areas[0].areaId
				this.getDevicesData()
				setTimeout(e=>{this.getAccessData()},2000)
			})
		},
		watch:{
			areaId(n,o){
				this.areaId = n
				this.accessList = [{}]
				this.accessRecorList = []
				this.monitorFilterText = ''
				this.getDevicesData()
				setTimeout(e=>{this.getAccessData()},2000)
			}
		},
		methods: {
			getAccessData() {
				if (this.areaId == 2) {
					var HikVisionDB = require('../../../wamp/WampHikVisionDB');
					var param = JSON.stringify({
						Start: 0,
						Num: 10
					})
					HikVisionDB.EnterLeaveSelect(param, result => {
						result = JSON.parse(result).EnterLeaveLog;
						const {
							EnterDate,
							FacePic,
							Name
						} = result[0];
						this.$forceUpdate();
						this.$set(this.accessList[0], 'Name', Name)
						this.$set(this.accessList[0], 'FacePic', FacePic)
						this.$set(this.accessList[0], 'EnterDate', EnterDate)
						this.accessRecorList = this.accessRecorList.concat(result)
					})
				}
			},

			getDevicesData() {
				GetSecurityDevices(this.areaId).then(res => {
					let monitorArr = []
					let id = 0
					res.data.data.devices.map((item, index) => {
						if (item.device_class_name == '门禁设备') {
							this.$set(this.accessList[0], 'deviceName', item.device_name)
							this.getAccessData()
						} else if (item.device_class_name == '监控设备') {
							// console.log(JSON.parse(item.device_details).roomName)
							monitorArr.push({
								id: id++,
								videoName: item.device_name,
								videoCode: JSON.parse(item.device_details).roomName
							})
						}
					})
					this.videoList = monitorArr
				})
			},

			query() {
				
			},

			changeSite(value) {
				this.areaId = value
				this.accessList = [{}]
				this.accessRecorList = []
				this.monitorFilterText = ''
				this.getDevicesData()

			},

			changeVideo(value) {
				this.currentVideoIndex = value.id
			},

			monitorFilter(item) {
				// if (!this.monitorFilterText) {
				// 	return true
				// }
				// return item.videoName.indexOf(this.monitorFilterText) != -1
				if (!this.monitorFilterText) {
					return 300
				}
				// console.log(item.videoName.includes(this.monitorFilterText))
				if (item.videoName.includes(this.monitorFilterText)) {
					return 300
				} else {
					return 0
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	.btn-prev {
		width: 32rem;
		height: 32rem;
		background: url(../../../assets/img/prev.png);
		background-size: 100% 100%;
		margin-left: 8rem;
	}

	.btn-next {
		width: 32rem;
		height: 32rem;
		background: url(../../../assets/img/next.png);
		background-size: 100% 100%;
		margin-right: 8rem;
	}

	.content {
		.w(1600);
		.h(968);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.body {
		width: 100%;
		.h(870);
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		.left {
			.w(528);
			.h(870);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;

			.left-content {
				display: flex;
				.w(528);
				display: flex;
				flex-direction: column;
				justify-content: center;
				margin-left: -240/192vw;
				margin-top: 240/108vh;
				border-top: 1px solid rgba(0, 0, 0, 0.06);

				.noAccess {
					width: 100%;
					height: 100%;
					margin-top: 1810/108vh;
					background: #fff;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					.pic {
						.w(112);
						.h(117);
						background-image: url(../../../assets/img/门禁.png);
						background-size: 100% 100%;
					}

					.text {
						font-size: 18rem;
						color: #CCCCCC;
						margin-top: 400/108vh;
					}
				}
			}
		}

		.right {
			.w(1064);
			.h(870);
			background: #FFFFFF;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

			.right-video {
				.w(1016);
				.h(782);
				margin-top: 240/108vh;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				.v-hl-responsive>* {
					margin-right: 0 !important;
				}

				.bigVideo {
					.w(1016);
					.h(548);
					background: #eee;

					.noVideo {
						width: 100%;
						height: 100%;
						background: #fff;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						.pic {
							.w(99);
							.h(116);
							background-image: url(../../../assets/img/监控.png);
							background-size: 100% 100%;
						}

						.text {
							font-size: 18rem;
							color: #CCCCCC;
							margin-top: 400/108vh;
						}
					}
				}

				.videoListContainer {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					margin-top: 200/108vh;
					margin-bottom: 200/108vh;

					.videoList {
						font-size: 18rem;
					}

					.search {
						.h(30);
						.w(250);
						overflow: hidden;
						border-radius: 24rem;
						border: 1px solid rgba(0, 0, 0, 0.15);
						position: relative;
						display: flex;
						flex-wrap: nowrap;
						flex-direction: row;
						align-items: center;
						justify-content: space-between;

						input {
							width: 100%;
							height: 100%;
							padding: 0 20rem;
							font-size: 16rem;
							color: #000000;
							font-weight: 400;
							line-height: 48rem;
						}

						img {
							margin-right: 100/192vw;
							cursor: pointer;
							z-index: 99;
						}
					}
				}

			}

			.record {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;

				.record-head {
					width: 100%;
					.h(90);
					display: flex;
					align-items: center;
					justify-content: space-between;

					.date-picker {
						padding-left: 24rem;
					}

					.button {
						padding-left: 24rem;
					}

					.close {
						padding-right: 24rem;
						cursor: pointer;
					}
				}

				.record-body {
					width: 96%;
					.h(780);
				}
			}
		}
	}
</style>